import AcDcPowerSupplies from './AcDcPowerSupplies'
import DcDcConverters from './DcDcConverters'
import EmiFilters from './EmiFilters'
import HighVoltageAcDc from './HighVoltageAcDc'
import HighVoltageDcDc from './HighVoltageDcDc'
import HighVoltagePowerSupplies from './HighVoltagePowerSupplies'
import RfPower from './RfPower'

export default {
    'ac-dc-power-supplies': AcDcPowerSupplies,
    'dc-dc-converters': DcDcConverters,
    'emi-filters': EmiFilters,
    'high-voltage-ac-dc': HighVoltageAcDc,
    'high-voltage-dc-dc': HighVoltageDcDc,
    'high-voltage-power-solutions': HighVoltagePowerSupplies,
    'rf-power': RfPower
}
